// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2r0LH","fresh":"Input_fresh__XOHr1"};